import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga'
import { Route } from 'react-router-dom'
import ReactPixel from 'react-facebook-pixel'
import { GA_TRACKING_ID, FB_PIXEL_EVENT_ID } from '../constants/AppConstants'
const GA_DEBUG = process.env.REACT_APP_GA_DEBUG || 'false'

class Analytics extends Component {
  componentDidMount() {
    this.logPageChange(this.props.location.pathname, this.props.location.search)
  }

  componentDidUpdate({ location: prevLocation }) {
    const { location: { pathname, search } } = this.props
    const isDifferentPathname = pathname !== prevLocation.pathname
    const isDifferentSearch = search !== prevLocation.search

    if (isDifferentPathname || isDifferentSearch) {
      this.logPageChange(pathname, search)
    }
  }

  logPageChange(pathname, search = '') {
    const page = pathname + search
    const { location } = window
    ReactGA.set({
      page,
      location: `${location.origin}${page}`,
      ...this.props.options
    })
    ReactGA.pageview(page)
    ReactPixel.track('ViewContent', {
      content_name: page
    })
  }

  render() {
    return null
  }
}

Analytics.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  }).isRequired,
  options: PropTypes.object
}

const RouteTracker = () => <Route component={Analytics} />

const init = (options = {}) => {
  const env = window._env_ || {}

  ReactGA.initialize(GA_TRACKING_ID, {
    debug: GA_DEBUG === 'true',
    ...options
  })
  ReactPixel.init(FB_PIXEL_EVENT_ID)
  return true
}

export default {
  Analytics,
  RouteTracker,
  init
}



// WEBPACK FOOTER //
// ./src/components/Analytics.js